import { border2, radius, spacing, token } from '@thiememeulenhoff/lit-sdk';
import * as coreTokens from '@thiememeulenhoff/tokens/core';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('card');

export const styles = css`
  :host {
    --card-border: ${border2(1, 'border-subtle')};
    --card-background-color: ${token('background-secondary')};
    --header-border: ${border2(1, 'border-subtle')};
    --header-padding: ${spacing(200)};
    --main-padding: ${spacing(200)};
    --footer-padding: ${spacing(200)};
    --footer-border: ${border2(1, 'border-subtle')};

    background-color: var(--card-background-color);
    border: var(--card-border);
    border-radius: ${radius('medium')};
    display: block;
    overflow: hidden;
  }

  :host > div {
    block-size: 100%;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: ${unsafeCSS(coreTokens.BreakpointSmall)}) {
    :host {
      max-inline-size: 100%;
    }
  }

  header {
    border-block-end: var(--header-border);
    display: block;
  }

  .a-card:not(.has-header) header {
    display: none;
  }

  .a-card.has-image:not(.has-header) header {
    display: block;

    slot[name='header'] {
      padding: unset;
    }
  }

  slot[name='image']::slotted(*) {
    display: block;
    inline-size: 100%;
    object-fit: cover;
    padding: unset;
  }

  slot[name='header'] {
    display: block;
    padding: var(--header-padding);
  }

  .no-padding-header slot[name='header'] {
    padding: unset;
  }

  main {
    display: block;
    flex-grow: 1;
    padding: var(--main-padding);
  }

  footer {
    border-block-start: var(--card-border);
    display: block;
    padding: var(--footer-padding);
  }

  .a-card:not(.has-footer) footer {
    display: none;
  }
`;
